import React from 'react'

interface PublicLayoutProps {
  children: React.ReactNode
}

/**
 * Public Layout
 *
 * Provides full-screen layout with no navigation chrome for public routes:
 * - Full-screen container (h-screen w-screen)
 * - No sidebar, no header/navbar
 * - Optimized for public-facing content (shared documents, public forms, etc.)
 * - Minimal branding (optional logo-only header)
 *
 * This layout is used for public routes that don't require authentication
 * (e.g., /s/:token for shared content)
 */
export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="h-screen w-screen overflow-hidden bg-brand-dark">
      {/* Optional: Minimal branded header (logo only, no navigation) */}
      <div className="absolute top-4 left-4 z-50">
        <h1 className="font-display text-xl font-bold text-brand-primary">
          Monumenta
        </h1>
      </div>

      {/* Full-screen content */}
      <div className="h-full w-full">
        {children}
      </div>
    </div>
  )
}
